import { Content } from "antd/lib/layout/layout";
import styled from "styled-components";

import { IconButton } from "components/forecasting/Shared";

// Styled components for properties panel
export const PropertiesContent = styled(Content)`
  background: #fff;
  display: flex;
  flex-direction: column;
`;

export const PropertiesHeader = styled.div`
  padding: 17px;
  border-bottom: 1px solid #e5e5e5;
`;

export const PropertiesScrollable = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
`;

export const PropertiesInner = styled.div`
  color: #666;
  font-size: 12px;
  text-align: center;
`;

export const CommandsContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  max-height: 100%;
  width: 100%;
  background: white;
  border-right: 1px solid #e5e5e5;
`;

export const CommandsListSection = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  width: 100%;
  width: 270px;
  min-width: 270px;
  background: white;
  border-right: 1px solid #e5e5e5;
`;

export const HeaderBar = styled.div`
  padding: 16px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DragHint = styled.div`
  font-size: 12px;
  color: #666;
  padding: 8px;
  background: #f9f9f9;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CollapseAllButton = styled(IconButton)`
  margin-left: 12px;
  font-size: 12px;
  display: flex;
  align-items: center;
`;

export const GroupsContainer = styled.div`
  overflow-y: auto;
  background: #fafbfc;
  margin-bottom: 10px;
  display: flex;
  margin: 2px;
  flex-direction: column;
  border-radius: 5px;
`;

export const GroupWrapper = styled.div`
  background: #fafbfc;
  margin-bottom: 10px;
  display: flex;
  margin: 2px;
  flex-direction: column;
  border: 1px solid lightgray;
  border-radius: 5px;
`;

export const CommandItem = styled.div<{
  isDragging: boolean;
  isDragOver: boolean;
  selected: boolean;
}>`
  background: ${({ isDragging, isDragOver, selected }) =>
    isDragging ? "#e6f7ff" : isDragOver || selected ? "#f0f0f0" : "white"};
  border-bottom: 1px solid #f0f0f0;
  padding: 5px;
  display: flex;
  align-items: center;

  cursor: grab;
  min-height: 40px;
  width: 100%;
  opacity: ${({ isDragging }) => (isDragging ? 0.5 : 1)};

  &:hover {
    box-shadow: 0 0 10px rgba(159, 169, 179, 0.5);
    z-index: 10; /* Ensure the hovered item is above others */
  }
`;

export const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid #e5e5e5;
  background: #f5f5f5;
`;

export const GroupTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
`;
